import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../components/SEO';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1595504128483-be3d75e7c82f?w=1920&q=80';

const SERVICE_CARDS = [
  { key: 'materials_s6', img: 'https://images.unsplash.com/photo-1747348491213-b2f17b322a14?w=600&q=80' },
  { key: 'materials_s7', img: 'https://customer-assets.emergentagent.com/job_0a2be3ae-68ce-414a-b1fb-5ae16a7a4416/artifacts/fxeut85b_struc.jpeg' },
  { key: 'materials_s8', img: 'https://customer-assets.emergentagent.com/job_a76be86f-7fd5-4574-bb32-409e5b263642/artifacts/e634f28f_puente-roto-630x378.jpg' },
  { key: 'materials_s9', img: 'https://customer-assets.emergentagent.com/job_0a2be3ae-68ce-414a-b1fb-5ae16a7a4416/artifacts/5mvwl27c_image.png' },
  { key: 'materials_s10', img: 'https://images.pexels.com/photos/46167/iron-rods-reinforcing-bars-rods-steel-bars-46167.jpeg?auto=compress&cs=tinysrgb&w=600' },
  { key: 'materials_s11', img: 'https://customer-assets.emergentagent.com/job_0a2be3ae-68ce-414a-b1fb-5ae16a7a4416/artifacts/kmqkgkf4_s-l400.jpg' },
];

export const StudioInfrastructureRisk = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen pt-16" style={{ fontFamily: 'IBM Plex Sans,sans-serif' }}>
      <SEO title="Infrastructure Risk | Durable Designs" path="/engineering/services/infrastructure-risk" />

      <section className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="absolute inset-0">
          <img src={HERO_IMAGE} alt="Infrastructure risk assessment" className="w-full h-full object-cover" />
          <div className="absolute inset-0 hero-gradient-directional" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto">
          <Link to="/engineering/services" className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-white transition-colors mb-8" data-testid="back-to-studios">
            <ArrowLeft className="w-4 h-4" /> All Services
          </Link>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white tracking-tighter" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }} data-testid="studio-infrastructure-heading">
            {t('eng_v2.infrastructure_title')}
          </h1>
        </div>
      </section>

      <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mb-12">
            <p className="text-base text-gray-600 leading-relaxed mb-4">
              {t('eng_v2.infra_intro_1')}
            </p>
            <p className="text-base text-gray-600 leading-relaxed">
              {t('eng_v2.infra_intro_2')}
            </p>
          </div>

          <h2 className="text-xs font-semibold tracking-[0.15em] uppercase text-gray-400 mb-8" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            Services
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-testid="infrastructure-service-cards">
            {SERVICE_CARDS.map((card) => (
              <div key={card.key} className="flex flex-col sm:flex-row border border-gray-200 overflow-hidden items-start" data-testid={`service-card-${card.key}`}>
                <div className="service-image-container">
                  <img
                    src={card.img}
                    alt={t(`services.${card.key}_alt`)}
                    width="600"
                    height="600"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="flex-1 p-5 sm:p-6 flex flex-col justify-center">
                  <h3 className="text-base font-semibold text-gray-900 mb-2" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                    {t(`services.${card.key}_title`)}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {t(`services.${card.key}_desc`)}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12">
            <Link to="/engineering/contact" className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 text-sm font-medium tracking-wide transition-colors" data-testid="studio-infrastructure-cta">
              Discuss a Project
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
export default StudioInfrastructureRisk;
